import classNames from 'classnames';
import styles from './AcademyHero.module.scss';
import { Container } from 'ui/components/4-habitats/Container';
import { Heading, RichText, Picture, LinkButton } from 'ui/components/1-atoms';
import { AcademyDetailTag, AcademyDetailTagProps } from 'ui/components/2-molecules';
import IconArrowRight from 'ui/icons/icon-arrow-right-web.svg';

export interface AcademyHeroProps {
	className?: string;
	dictionary?: { [key: string]: string };
	academyTitle?: string;
	academyType?: AcademyDetailTagProps['academyType'];
	academyTypeDisplayName?: string;
	academyStartDateTime?: Models.AcademyEntry['startDateTime'];
	localizedStartDateTime?: string;
	text?: string;
	link?: { url: string; name?: string; target?: string };
	signUpAriaLabel?: string;
	image?: Umbraco.Image;
	anchor?: string;
}

export const AcademyHero: React.FC<AcademyHeroProps> = ({
	className,
	signUpAriaLabel,
	academyType,
	academyTitle,
	academyStartDateTime,
	text,
	link,
	image,
	anchor,
	academyTypeDisplayName,
	localizedStartDateTime,
}) => {
	return (
		<section className={classNames(styles.AcademyHero, className)} {...(anchor ? { id: anchor } : {})}>
			<Container width="StandardWeb" className={classNames(styles.AcademyHero_wrapper)}>
				{image && (
					<div className={styles.AcademyHero_colRight}>
						<Picture
							url={image.url}
							focalPoint={image.focalPoint}
							properties={image.properties}
							className={styles.AcademyHero_imageElement}
						/>
					</div>
				)}
				<div className={styles.AcademyHero_colLeft}>
					<div className={styles.AcademyHero_headingsContainer}>
						{academyType && (
							<AcademyDetailTag className={styles.AcademyHero_academyTag} academyType={academyType}>
								{academyTypeDisplayName || academyType}
							</AcademyDetailTag>
						)}
						{academyStartDateTime && (
							<p className={styles.AcademyHero_metaDetails}>
								<time dateTime={academyStartDateTime}>{localizedStartDateTime}</time>
							</p>
						)}
						{academyTitle && (
							<Heading headingLevel="h2" style="displaySm" className={styles.AcademyHero_heading}>
								{academyTitle}
							</Heading>
						)}
					</div>
					<div className={styles.AcademyHero_descriptionContainer}>
						{text && <RichText variant="website" content={text} className={styles.AcademyHero_description} />}
						{link && (
							<LinkButton
								withBackIcon={<IconArrowRight />}
								style="primaryWeb"
								url={link.url}
								target={link.target}
								className={styles.AcademyHero_linkButton}
								title={signUpAriaLabel || link.name}
								ariaLabel={signUpAriaLabel || link.name}
							>
								{link?.name}
							</LinkButton>
						)}
					</div>
				</div>
			</Container>
		</section>
	);
};
